import { ApiResponse, EmptyApiResponse } from "../models/api-response.model";
import { DOW, TimeInterval } from "../models/module-manager/module-manager-settings.models";
import { ClearViewUtils } from "../utils";
import { CvApiServiceBase } from "./cv-api-service-base";

export class DateRangeSelectorServiceBase {

    constructor(
        fromSharedService: boolean = false,
        private cvApiService?: CvApiServiceBase,
    ) {
        if (fromSharedService)
            return DateRangeSelectorServiceBase.getServiceBase();

        if (!cvApiService)
            this.cvApiService = CvApiServiceBase.getServiceBase();
    }

    static getServiceBase(): DateRangeSelectorServiceBase {
        return ClearViewUtils.getSharedService(DateRangeSelectorServiceBase, 'DateRangeSelectorServiceBase');
    }

    saveDateRange(pageName: string, dateRangeName: string): Promise<ApiResponse<EmptyApiResponse>> {
        return this.cvApiService.post(`/api/v1/date-range-selector/${pageName}/date-range`, JSON.stringify(dateRangeName));
    }

    saveDaysOfWeek(pageName: string, dow: DOW) {
        return this.cvApiService.post(`/api/v1/date-range-selector/${pageName}/days-of-week`, dow);
    }

    saveTimeSettings(pageName: string, isEnabled: boolean, minTime: number, maxTime: number, invertTimeSelector: boolean = null) {
        return this.cvApiService.post(`/api/v1/date-range-selector/${pageName}/times`, { isEnabled, minTime, maxTime, invertTimeSelector });
    }

    saveIntervalSettings(pageName: string, intervalAmt: number, interval: TimeInterval) {
        return this.cvApiService.post(`/api/v1/date-range-selector/${pageName}/interval`, { intervalAmt, interval });
    }

    saveInvertTimeSelectorSetting(pageName: string, invertTimeSelector: boolean) {
        return this.cvApiService.post(`/api/v1/date-range-selector/${pageName}/invert-time-selector`, { invertTimeSelector });
    }
}
